import { useMemo } from 'react';
import styled from '@emotion/styled';
import { themeGet } from 'styled-system';

import Button from '@/components/Button';
import { searchPanelCtaDataLayerEvent } from '@/v2/components/pages/PackageViewV2/utils/dataLayer';
import { useGA4Events } from '@/v2/hooks/featureFlags/ga4Events/useGA4Events';
import { dataLayer } from '@/v2/utils/dataLayer';

const StyledButton = styled(Button)`
  height: 64px;
  font-size: 1.25rem;
  line-height: 1.2;

  &&&:disabled {
    background: ${themeGet('buttons.primary.backgroundColor')};
    color: ${themeGet('buttons.primary.color')};
    opacity: 0.5;
  }
`;

export type CtaButtonProps = {
  hasSelection: boolean;
  onReserve: () => void;
  onCheckAvailability: () => void;
  isDisabled?: boolean;
};

const CtaButton = ({
  hasSelection,
  onReserve,
  onCheckAvailability,
  isDisabled,
}: CtaButtonProps) => {
  const shouldUseNewEvents = useGA4Events();

  const { onClick, text } = useMemo(() => {
    if (hasSelection) {
      return {
        text: 'Reserve',
        onClick: onReserve,
      };
    }

    return {
      text: 'Check availability',
      onClick: onCheckAvailability,
    };
  }, [hasSelection, onCheckAvailability, onReserve]);

  const handleClick = () => {
    if (shouldUseNewEvents) {
      dataLayer.ctaClickEvent({
        itemText: text,
      });
    }
    searchPanelCtaDataLayerEvent({ action: text });
    onClick();
  };

  return (
    <StyledButton onClick={handleClick} disabled={isDisabled}>
      {text}
    </StyledButton>
  );
};

export default CtaButton;
